import React, { useCallback } from "react";
import PropTypes from "prop-types";
import EntitiesSelector, { commonPropTypes } from "./entities-selector";

const query = `
query EventTypes($contractId: ID, $offset: Int, $limit: Int) {
  eventTypes(contractId: $contractId, offset: $offset, limit: $limit) {
    items {
      id
      name
      description
    }
    total
  }
}
`;

const EventTypeSelectMultiple = ({
  className,
  id = "allowedEventTypes",
  name = "allowedEventTypes",
  isInsideForm,
  ...props
}) => {
  const handleDataFromResponse = useCallback(data => data.eventTypes, []);
  const handleGetValue = useCallback(element => element.id, []);
  const handleGetLabel = useCallback(element => element.description, []);

  return (
    <EntitiesSelector
      isInsideForm={isInsideForm}
      className={className}
      multiple
      id={id}
      name={name}
      queryString={query}
      onGetDataFromResponse={handleDataFromResponse}
      onGetValue={handleGetValue}
      onGetLabel={handleGetLabel}
      {...props}
    />
  );
};

EventTypeSelectMultiple.propTypes = {
  ...commonPropTypes,
  /**
   * Valor del selector
   */
  value: PropTypes.array,
};

export default EventTypeSelectMultiple;
